export const SHOW_HIDE_CART = 'SHOW_HIDE_CART'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_ITEM = 'REMOVE_ITEM'
export const INCREMENT = 'INCREMENT'
export const DECREMENT = 'DECREMENT'
export const GET_TOTAL = 'GET_TOTAL'
export const GET_TOTAL_AMOUNT = 'GET_TOTAL_AMOUNT'